// ===============================================
// 🔐 PÁGINA DE LOGIN - INHOLDING
// ===============================================
// Arquivo: src/pages/Login/index.js

import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { Navigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import './Login.css';

const Login = () => {
  const [usuario, setUsuario] = useState('');
  const [senha, setSenha] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { login, isAuthenticated, loading } = useAuth();

  // Se já estiver autenticado, redirecionar para expedição
  if (isAuthenticated) {
    return <Navigate to="/expedition" replace />;
  }

  // Mostrar loading enquanto verifica autenticação
  if (loading) {
    return (
      <div className="login-loading">
        <div className="loading-spinner"></div>
        <p>Verificando autenticação...</p>
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!usuario.trim() || !senha.trim()) {
      toast.error('Por favor, preencha todos os campos');
      return;
    }

    setIsLoading(true);
    
    const result = await login(usuario.trim(), senha);
    
    if (result.success) {
      toast.success(result.message);
      // Navegação será feita automaticamente pelo Navigate acima
    } else {
      toast.error(result.message);
    }
    
    setIsLoading(false);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSubmit(e);
    }
  };

  return (
    <div className="login-container">
      <div className="login-background">
        <div className="background-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
        </div>
      </div>
      
      <div className="login-content">
        <div className="login-card">
          <div className="login-header">
            <div className="login-logo">
              <div className="logo-icon">📦</div>
              <h1>PCP</h1>
            </div>
            <h2>Controle de Expedição</h2>
            <p>Acesse o sistema de controle de envio e recebimento</p>
          </div>

          <form className="login-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="usuario">Usuário</label>
              <div className="input-wrapper">
                <input
                  id="usuario"
                  type="text"
                  value={usuario}
                  onChange={(e) => setUsuario(e.target.value)}
                  onKeyDown={handleKeyPress}
                  placeholder="Digite seu usuário"
                  disabled={isLoading}
                  autoComplete="username"
                  autoFocus
                />
                <div className="input-icon">👤</div>
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="senha">Senha</label>
              <div className="input-wrapper">
                <input
                  id="senha"
                  type={showPassword ? 'text' : 'password'}
                  value={senha}
                  onChange={(e) => setSenha(e.target.value)}
                  onKeyDown={handleKeyPress}
                  placeholder="Digite sua senha"
                  disabled={isLoading}
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                  disabled={isLoading}
                >
                  {showPassword ? '👁️' : '👁️‍🗨️'}
                </button>
              </div>
            </div>

            <button
              type="submit"
              className={`login-button ${isLoading ? 'loading' : ''}`}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <div className="button-spinner"></div>
                  Entrando...
                </>
              ) : (
                <>
                  🚀 Entrar
                </>
              )}
            </button>
          </form>

          <div className="login-footer">
            <div className="login-info">
              <p><strong></strong> </p>
              <p><strong></strong> </p>
            </div>
            
            <div className="login-version">
              <span>v3.2.1</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;